import React, { useState } from 'react'

import { useNavigate } from '@lib/react-router-dom'

import { isOne } from '@utils/validations'

import { Box } from '@shared/components/Box'

import { JourneyStep } from './JourneyStep'

export const JourneyPage: React.FC = () => {
  const [screenNumber, setScreenNumber] = useState(1)
  const navigate = useNavigate()

  const handleNext = () => setScreenNumber(2)
  const handleStartJourney = () => navigate('/dashboard/traders-room')

  return (
    <div>
      <JourneyStep
        stepNumber={screenNumber}
        nextScreen={handleNext}
        startJourney={handleStartJourney}
      />

      <Box flex justify='center' pt='x48' pb='x48' gap='x24'>
        <Box
          radius='round'
          style={{ width: 12, height: 12 }}
          onClick={() => setScreenNumber(1)}
          bg={isOne(screenNumber) ? 'surface-disabled-med-em' : 'surface-surface-3'}
        />
        <Box
          radius='round'
          style={{ width: 12, height: 12 }}
          onClick={() => setScreenNumber(2)}
          bg={screenNumber === 2 ? 'surface-disabled-med-em' : 'surface-surface-3'}
        />
      </Box>
    </div>
  )
}
